var _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericErrorImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7235 14.7768C46.0216 3.07498 26.98 3.07383 15.2769 14.7768C3.57379 26.4797 3.57494 45.5198 15.2769 57.2228C26.9789 68.9258 46.0204 68.9258 57.7235 57.2228C69.4255 45.5198 69.4255 26.4786 57.7235 14.7768Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2778 14.7777C26.9822 3.07351 46.0194 3.0747 57.7226 14.7777C69.4259 26.4808 69.4257 45.5178 57.7227 57.2218C46.0185 68.9259 26.981 68.9261 15.2777 57.2218C3.57474 45.5179 3.57341 26.4819 15.2778 14.7777ZM53.8657 18.6347C44.2925 9.06163 28.7088 9.06072 19.1347 18.6347C9.56074 28.2085 9.56152 43.7909 19.1348 53.3651C28.7078 62.9388 44.2914 62.939 53.8656 53.3651M53.8657 18.6347C63.4386 28.2075 63.4387 43.791 53.8656 53.3651L53.8657 18.6347Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6928 41.0092C37.6337 41.571 37.1128 42 36.4899 42C35.8664 42 35.3453 41.5703 35.2868 41.008L33.5135 23.9728C33.3475 22.3782 34.732 21 36.5 21C38.2692 21 39.6542 22.3801 39.4862 23.9757L37.6928 41.0092Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 22.1667C35.5754 22.1667 34.8513 22.8905 34.9381 23.7281L35.7146 31.22L36.4911 38.7119L37.2764 31.2208L38.0617 23.7296C38.1496 22.8915 37.4253 22.1667 36.5 22.1667ZM32.0203 23.9785C31.7713 21.5762 33.8481 19.5 36.5 19.5C39.1539 19.5 41.2313 21.579 40.9793 23.9828L39.1653 41.2867C39.0338 42.5417 37.8753 43.5 36.4897 43.5C35.1031 43.5 33.9441 42.5402 33.8139 41.2841L32.0203 23.9785Z",
    fill: "#E1E1E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 51,
    r: 3,
    fill: "#E1E1E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericErrorImg);
export default __webpack_public_path__ + "static/media/GenericErrorImg.0fce78dfa57b5f21899c1510eb700fc9.svg";
export { ForwardRef as ReactComponent };